import React from 'react'

export type SidebarContextType = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  isCollapsed: boolean
  setIsCollapsed: (isCollapsed: boolean) => void
  toggleOpen: () => void
  toggleCollapsed: () => void
}

export const SidebarContext = React.createContext<SidebarContextType>({
  isOpen: false,
  setIsOpen: () => {},
  isCollapsed: true,
  setIsCollapsed: () => {},
  toggleOpen: () => {},
  toggleCollapsed: () => {},
})
